import { render, staticRenderFns } from "./UserCard.vue?vue&type=template&id=0a729b23&"
import script from "./UserCard.controller.js?vue&type=script&lang=js&"
export * from "./UserCard.controller.js?vue&type=script&lang=js&"
import style0 from "./UserCard.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports